export default {
  no_items: 'Ничего не найдено',
  placeholder_search: 'Искать среди {{ total }} работ',
  placeholder_search_view: 'Введите название или художника',
  no_request_result: 'По запросу «{{ request }}» ничего не найдено',
  no_filter_result: 'По выбранной фильтрации ничего не найдено',
  name: 'Подборки',
  editor_select: 'Выбор редакции',
};
